import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Input, Table } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const SellerApiWarehouse = () => {
  const crumbList = [
    { tittle: '외부 api 송출 내역', url: '' },
    { tittle: '외부 api 송출 내역 조회', url: '' }
  ];

  const columns = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Seller Name',
      dataIndex: 'name'
    },
    {
      title: 'Seller E-mail Address',
      dataIndex: 'email'
    },
    {
      title: 'Seller Address',
      dataIndex: 'address'
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber'
    },
    {
      title: 'Website URL',
      dataIndex: 'websiteUrl'
    },
    {
      title: 'Scale',
      dataIndex: 'scale'
    },
    {
      title: 'Country Code',
      dataIndex: 'countryCode'
    },
    {
      title: 'Manager Name',
      dataIndex: 'managerName'
    }
  ];

  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const [token, setToken] = useState('');
  const fetchData = async (page: number) => {
    const res = await axios.get(
      `https://public-api.buskfulfillment.com/api/v1/seller/warehouses?page=${page}`,
      {
        headers: {
          'X-Busk-Api-Token': token
        }
      }
    );
    setTotalPage(res.data.lastPage * 10);
    setData(res.data.data);
  };

  console.log(data);
  return (
    <div>
      <BreadcrumbList listBreadcrumb={crumbList} />
      <div className="busk-container">
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: 20,
            marginBottom: 20
          }}
        >
          <Input
            placeholder="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <Button onClick={() => fetchData(0)}>Fetch</Button>
        </div>
        <Table
          pagination={{
            total: totalPage,
            current: currentPage,
            showSizeChanger: false,
            onChange: (page, limit) => {
              fetchData(page - 1);
              setCurrentPage(page);
            }
          }}
          columns={columns}
          scroll={{ x: 'max-content' }}
          dataSource={data}
        />
      </div>
    </div>
  );
};

export default SellerApiWarehouse;
